import {NUMBER} from 'zobject/data-types.js';
import {MIDI_FX, AUDIO_FX} from 'constants/effect-types.js';
import {EFFECT} from 'constants/object-types.js';


export const connectionJson = (connections) => {
    let output = {};
    let midiEffects = [];
    let effects = [];
    for (let key in connections) {
        let o = [];
        for (let {node, type} of connections[key]) {
            let subType, min, max, round, value;
            if (node.zObject) {
                node = node.zObject;
            }
            if (!node.getObjectType) {
                continue;
            }
            if (node.getObjectType() === "zmessage") {
                subType = node.type;
                min = node.min;
                max = node.max;
                round = node.round;
                value = node.message;
            }
            if (node.getObjectType() === EFFECT) {
                if (node.getEffectType() === MIDI_FX) {
                    midiEffects.push(node);
                }
                if (node.getEffectType() === AUDIO_FX) {
                    effects.push(node);
                }
            }
            o.push({
                node: node.getObjectType(),
                type, subType,
                min,
                max,
                round,
                value,
                name: node.name
            });
        }
        output[key] = o;
    }
    return {json: output, midiEffects, effects};
};

const findNode = (subSequence, node, name) => {
    if (!name) {
        return undefined;
    }
    let actualNode = undefined;
    if (name !== "three.canvas") {
        let pad = subSequence.findNodeByName(name)[0];
        if (pad) {
            let _pad = name === "pad" ? pad.effect.pad : pad;
            return {node: _pad, zobject: pad};
        }
    }
    return undefined;
};

export const connectPresetToRemainingGraph = (subpatch, inbound, outbound, objectDependencies, hide) => {
    let windowPositions = {};
    // go thru the inbound and outbound and try to connect it to
    // parts of the graph
    let subSequence = subpatch.subSequence.getRootSubSequence ?
        subpatch.subSequence.getRootSubSequence() : subpatch.subSequence;

    let objectsCreated = [];
    if (objectDependencies) {
        let {midiEffects, effects} = objectDependencies;
        let track = subpatch.sequencerEngine.getSelectedTrack();
        if (track) {
            for (let fx of midiEffects) {
                let {effect, bulk} = track.midiEffects.addEffectJson(fx);
                objectsCreated.push(effect);
            }
            for (let fx of effects) {
                let {effect, bulk} = track.effectsChain.addEffectJson(
                    fx, subpatch.sequencerEngine.tracks, track.trackNumber);
                objectsCreated.push(effect);
            }
        }
    }

    let off = 0;
    let toExecute = [];
    for (let key in inbound) {
        for (let {node, name, type, value, subType, min, max, round} of inbound[key]) {
            if (!name || name === "subpatch") {
                continue;
            }
            let actualNode;
            if (node === "zmessage" && subType === NUMBER) {
                let position = subpatch.sequencerEngine.state.windows.windowPositions[subpatch.zObject.id];
                off += 60;
                let x = position && position.x + off;
                let y = position && Math.max(0, position.y - 60);
                actualNode = {
                    node: subSequence.createZMessage(x, y, subType)
                };
                windowPositions[actualNode.node.id] = {x,y};
           } else {
               let _objectCreated = objectsCreated.find(x => x.name === name);
               if (_objectCreated) {
                   actualNode = _objectCreated;
               } else {
                   if (name === "pad") {
                       actualNode = findNode(subSequence, node, name);
                   } else {
                       actualNode = subSequence.createZObject(1, 1, name);
                       if (hide) {
                           actualNode.hide();
                       }
                       windowPositions[actualNode.id] = {x:1,y:1};
                       objectsCreated.push(actualNode);
                   }
               }
            }

            if (actualNode.effect) {
                subpatch.connectInlet(key, actualNode.effect, type);
            } else {
                subpatch.connectInlet(key, actualNode.node || actualNode, type);
            }
            if (value !== undefined && actualNode && actualNode.node) {
                actualNode.node.min = min;
                actualNode.node.max = max;
                actualNode.node.round = round;
                actualNode.node.text = parseFloat(value);
                actualNode.node.storedMessage = parseFloat(value);
                toExecute.push(actualNode.node);
            }
        }
    }

    for (let key in outbound) {
        for (let {name, node, type, subType} of outbound[key]) {
            if (!name) {
                continue;
            }
            let actualNode;
            if (node === "zmessage" && subType === NUMBER) {
                actualNode = {
                    node: subSequence.createZMessage(undefined, undefined, subType)
                };
            } else {
                let _objectCreated = objectsCreated.find(x => x.name === name);
                if (_objectCreated) {
                    actualNode = _objectCreated;
                } else {
                    //if (!actualNode) {
                    if (name === "pad") {
                        actualNode = findNode(subSequence, node, name);
                        continue;
                    } else {
                        actualNode = findNode(subSequence, node, name);
                        if (!actualNode) {
                            actualNode = subSequence.createZObject(1, 1, name);
                        }
                        if (hide) {
                            actualNode.hide();
                        }
                        windowPositions[actualNode.id] = {x:1, y:1};
                        objectsCreated.push(actualNode);
                   }
                }
            }

            if (actualNode.node) {
                actualNode.node.connectInlet(type, subpatch, key);
            } else if (actualNode.effect) {
                actualNode.effect.connectInlet(type, subpatch, key);
            } else {
                actualNode.connectInlet(type, subpatch, key);
            }
        }
    }

    toExecute.forEach(node => {
        node.execute();
    });

    setTimeout(() => {
        toExecute.forEach(node => {
            node.execute();
        });
    }, 1000);

    return windowPositions;
};
